// A verified account/company identity is supplied by the authenticated app shell.
let currentScope: string | null = null;
export function setMobileQueueScope(scope: string | null) { currentScope = scope; }
export function mobileQueueScope() { return currentScope; }
export function requireMobileQueueScope() {
 if (!currentScope) throw new Error('Reconnect and sign in once before saving offline actions.');
 return currentScope;
}
export function belongsToMobileScope(action: { scope?: string }, scope: string | null) {
 return !!scope && action.scope === scope;
}
